import { useNav, nextInstruction } from '../state/nav'
import { formatKm } from '../lib/geo'
import { IconVoiceOn, IconVoiceOff, IconClose } from './icons'

/** Valhalla maneuver type → arrow glyph */
function arrowFor(sign: number): string {
  if ([9, 14, 25].includes(sign)) return '↰'
  if ([10, 15].includes(sign)) return '↖'
  if ([11, 16].includes(sign)) return '↑'
  if ([12, 17].includes(sign)) return '↗'
  if ([13, 18, 26].includes(sign)) return '↱'
  if ([19, 20].includes(sign)) return '⟲'
  if ([4, 5, 6].includes(sign)) return '⚑'
  if ([1, 2, 3].includes(sign)) return '▲'
  if ([37, 38, 39].includes(sign)) return '⇑'
  return '↑'
}

export default function NavOverlay() {
  const nav = useNav()
  if (!nav.active) return null

  const next = nextInstruction(nav)
  const remainingM = Math.max(0, nav.totalM - nav.alongM)

  return (
    <>
      <div className={`nav-banner${nav.offRoute ? ' offroute' : ''}`}>
        {nav.offRoute ? (
          <>
            <span className="arrow">⚠</span>
            <div>
              <div className="n-dist">Off route</div>
              <div className="n-text">{nav.rerouting ? 'Recalculating…' : 'Head back to the marked line'}</div>
            </div>
          </>
        ) : next ? (
          <>
            <span className="arrow">{arrowFor(next.instruction.sign)}</span>
            <div>
              <div className="n-dist">{formatKm(next.inM)}</div>
              <div className="n-text">{next.instruction.text}</div>
            </div>
          </>
        ) : (
          <>
            <span className="arrow">▲</span>
            <div>
              <div className="n-dist">{formatKm(remainingM)}</div>
              <div className="n-text">Follow the route{nav.tourName ? ` — ${nav.tourName}` : ''}</div>
            </div>
          </>
        )}
      </div>

      <div className="nav-bottom">
        <div className="stats">
          <div className="stat">
            <div className="v">{formatKm(remainingM)}</div>
            <div className="l">To go</div>
          </div>
          <div className="stat">
            <div className="v">{formatKm(nav.alongM)}</div>
            <div className="l">Done</div>
          </div>
          <div className="stat">
            <div className="v">{Math.round((nav.alongM / Math.max(1, nav.totalM)) * 100)}%</div>
            <div className="l">Progress</div>
          </div>
        </div>
        <button
          className="icon-btn"
          title={nav.voice ? 'Mute voice' : 'Unmute voice'}
          onClick={() => nav.setVoice(!nav.voice)}
        >
          {nav.voice ? <IconVoiceOn /> : <IconVoiceOff />}
        </button>
        <button className="btn sm danger" onClick={nav.stop}>
          <IconClose /> End
        </button>
      </div>

      {nav.gpsError && <div className="toast">GPS: {nav.gpsError}</div>}
    </>
  )
}
